module.exports = __webpack_public_path__ + "static/media/history_30.93dd5626.jpg";